const getters = {
  device: state => state.app.device,
  theme: state => state.app.theme,
  color: state => state.app.color,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  nickname: state => state.user.name,
  welcome: state => state.user.welcome,
  roles: state => state.user.roles,
  userInfo: state => state.user.info,
  addRouters: state => state.permission.addRouters,
  multiTab: state => state.app.multiTab,
  /* Added by L.X */
  id: state => state.user.id,
  name: state => state.user.name,
  permissions: state => state.user.permissions,
  title: state => state.user.title,
  corpName: state => state.user.corpName,
  messageNum: state => state.user.messageNum
}

export default getters
